"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * AdminApi - axios parameter creator
 * @export
 */
const AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Free form user account lookup. Lookup by first, last name, email, phone number, or friends & family invitation code.
         * @param {string} [q] Search term for given name, family name, email, phone number, or friends &amp; family invitation code. It should have 3 or more characters to get result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAccountsGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ q }, options = {}) {
            const localVarPath = `/v1/admin/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/accounts`,
                sdkMethod: 'v1AdminAccountsGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/admin/cache/b2b`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/cache/b2b`,
                sdkMethod: 'v1AdminCacheB2bDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Admin API request handler.
         * @summary Deletes partner resources from cache for given identifiers.
         * @param {string} partnerId Partner ID
         * @param {string} [partnerSlug] Partner Slug
         * @param {string} [parentPartnerId] Parent Partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, partnerSlug, parentPartnerId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminCacheB2bPartnersPartnerIdDelete', 'partnerId', partnerId);
            const localVarPath = `/v1/admin/cache/b2b/partners/{partner_id}`.replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (partnerSlug !== undefined) {
                localVarQueryParameter['partner_slug'] = partnerSlug;
            }
            if (parentPartnerId !== undefined) {
                localVarQueryParameter['parent_partner_id'] = parentPartnerId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/cache/b2b/partners/{partner_id}`,
                sdkMethod: 'v1AdminCacheB2bPartnersPartnerIdDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {string} partnerId Partner ID
         * @param {string} [isDependentGroup] Is dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, isDependentGroup, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete', 'partnerId', partnerId);
            const localVarPath = `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships`.replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (isDependentGroup !== undefined) {
                localVarQueryParameter['is_dependent_group'] = isDependentGroup;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships`,
                sdkMethod: 'v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Clears data cached in the referrals key for the specified partner id and sponsorship id. Clears data for all supported languages.
         * @summary Clears cached referral data.
         * @param {string} partnerId Partner ID
         * @param {string} sponsorshipId Sponsorship ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, sponsorshipId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete', 'partnerId', partnerId);
            // verify required parameter 'sponsorshipId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete', 'sponsorshipId', sponsorshipId);
            const localVarPath = `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships/{sponsorship_id}/referrals`
                .replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${'sponsorship_id'}}`, encodeURIComponent(String(sponsorshipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers
                ? baseOptions.headers
                : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships/{sponsorship_id}/referrals`,
                sdkMethod: 'v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns partner configs for file-based eligibility partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminEligibilityPartnersGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/admin/eligibility-partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/eligibility-partners`,
                sdkMethod: 'v1AdminEligibilityPartnersGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Eligibility Search Admin API handler that fuzzy searches members on a partner\'s eligibility list.
         * @summary Eligibility Search Admin API handler
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdEligibilityMembersSearchGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ partnerId, memberId, email, firstName, lastName, dob, subscriberId, partnerMemberId, }, options = {}) {
            // verify required parameter 'partnerId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminPartnersPartnerIdEligibilityMembersSearchGet', 'partnerId', partnerId);
            const localVarPath = `/v1/admin/partners/{partner_id}/eligibility/members/search`.replace(`{${'partner_id'}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }
            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }
            if (dob !== undefined) {
                localVarQueryParameter['dob'] =
                    dob instanceof Date
                        ? dob.toISOString().substr(0, 10)
                        : dob;
            }
            if (subscriberId !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriberId;
            }
            if (partnerMemberId !== undefined) {
                localVarQueryParameter['partner_member_id'] = partnerMemberId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/partners/{partner_id}/eligibility/members/search`,
                sdkMethod: 'v1AdminPartnersPartnerIdEligibilityMembersSearchGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {number} recipientId Recipient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRecipientRecipientIdGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminRecipientRecipientIdGet', 'recipientId', recipientId);
            const localVarPath = `/v1/admin/recipient/{recipient_id}`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/recipient/{recipient_id}`,
                sdkMethod: 'v1AdminRecipientRecipientIdGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns user sponsor, dependents, and parents.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminUsersUserIdGet', 'userId', userId);
            const localVarPath = `/v1/admin/users/{user_id}`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/users/{user_id}`,
                sdkMethod: 'v1AdminUsersUserIdGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns timestamp when user active tokens got blocked.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedGet: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminUsersUserIdTokensBlockedGet', 'userId', userId);
            const localVarPath = `/v1/admin/users/{user_id}/tokens/blocked`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/users/{user_id}/tokens/blocked`,
                sdkMethod: 'v1AdminUsersUserIdTokensBlockedGet',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invalidates active access tokens of the user specified by user_id parameter.
         * @summary Blocks user active tokens
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedPost: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminUsersUserIdTokensBlockedPost', 'userId', userId);
            const localVarPath = `/v1/admin/users/{user_id}/tokens/blocked`.replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/admin/users/{user_id}/tokens/blocked`,
                sdkMethod: 'v1AdminUsersUserIdTokensBlockedPost',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdminApiAxiosParamCreator = AdminApiAxiosParamCreator;
/**
 * AdminApi - functional programming interface
 * @export
 */
const AdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AdminApiAxiosParamCreator)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Free form user account lookup. Lookup by first, last name, email, phone number, or friends & family invitation code.
         * @param {string} [q] Search term for given name, family name, email, phone number, or friends &amp; family invitation code. It should have 3 or more characters to get result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAccountsGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminAccountsGet(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCacheB2bDelete(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Admin API request handler.
         * @summary Deletes partner resources from cache for given identifiers.
         * @param {string} partnerId Partner ID
         * @param {string} [partnerSlug] Partner Slug
         * @param {string} [parentPartnerId] Parent Partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCacheB2bPartnersPartnerIdDelete(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {string} partnerId Partner ID
         * @param {string} [isDependentGroup] Is dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Clears data cached in the referrals key for the specified partner id and sponsorship id. Clears data for all supported languages.
         * @summary Clears cached referral data.
         * @param {string} partnerId Partner ID
         * @param {string} sponsorshipId Sponsorship ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns partner configs for file-based eligibility partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminEligibilityPartnersGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminEligibilityPartnersGet(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Eligibility Search Admin API handler that fuzzy searches members on a partner\'s eligibility list.
         * @summary Eligibility Search Admin API handler
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {number} recipientId Recipient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRecipientRecipientIdGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminRecipientRecipientIdGet(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns user sponsor, dependents, and parents.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminUsersUserIdGet(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns timestamp when user active tokens got blocked.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedGet(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminUsersUserIdTokensBlockedGet(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Invalidates active access tokens of the user specified by user_id parameter.
         * @summary Blocks user active tokens
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedPost(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminUsersUserIdTokensBlockedPost(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AdminApiFp = AdminApiFp;
/**
 * AdminApi - factory interface
 * @export
 */
const AdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AdminApiFp)(configuration);
    return {
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Free form user account lookup. Lookup by first, last name, email, phone number, or friends & family invitation code.
         * @param {string} [q] Search term for given name, family name, email, phone number, or friends &amp; family invitation code. It should have 3 or more characters to get result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminAccountsGet(params, options) {
            return localVarFp
                .v1AdminAccountsGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bDelete(params, options) {
            return localVarFp
                .v1AdminCacheB2bDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Admin API request handler.
         * @summary Deletes partner resources from cache for given identifiers.
         * @param {string} partnerId Partner ID
         * @param {string} [partnerSlug] Partner Slug
         * @param {string} [parentPartnerId] Parent Partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdDelete(params, options) {
            return localVarFp
                .v1AdminCacheB2bPartnersPartnerIdDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {string} partnerId Partner ID
         * @param {string} [isDependentGroup] Is dependent group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options) {
            return localVarFp
                .v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Clears data cached in the referrals key for the specified partner id and sponsorship id. Clears data for all supported languages.
         * @summary Clears cached referral data.
         * @param {string} partnerId Partner ID
         * @param {string} sponsorshipId Sponsorship ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options) {
            return localVarFp
                .v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns partner configs for file-based eligibility partners
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminEligibilityPartnersGet(params, options) {
            return localVarFp
                .v1AdminEligibilityPartnersGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Eligibility Search Admin API handler that fuzzy searches members on a partner\'s eligibility list.
         * @summary Eligibility Search Admin API handler
         * @param {string} partnerId The ID of the partner
         * @param {string} [memberId] Id of the member to search
         * @param {string} [email] Email of the member to search
         * @param {string} [firstName] First name of the member to search
         * @param {string} [lastName] Last name of the member to search
         * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
         * @param {string} [subscriberId] SubscriberId of the member to search.
         * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options) {
            return localVarFp
                .v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Admin API request handler.
         * @summary Admin API handler
         * @param {number} recipientId Recipient ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRecipientRecipientIdGet(params, options) {
            return localVarFp
                .v1AdminRecipientRecipientIdGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns user sponsor, dependents, and parents.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdGet(params, options) {
            return localVarFp
                .v1AdminUsersUserIdGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns timestamp when user active tokens got blocked.
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedGet(params, options) {
            return localVarFp
                .v1AdminUsersUserIdTokensBlockedGet(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Invalidates active access tokens of the user specified by user_id parameter.
         * @summary Blocks user active tokens
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminUsersUserIdTokensBlockedPost(params, options) {
            return localVarFp
                .v1AdminUsersUserIdTokensBlockedPost(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.AdminApiFactory = AdminApiFactory;
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
class AdminApi extends base_1.BaseAPI {
    /**
     * URL `/v1/admin/accounts`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Free form user account lookup. Lookup by first, last name, email, phone number, or friends & family invitation code.
     * @param {string} [q] Search term for given name, family name, email, phone number, or friends &amp; family invitation code. It should have 3 or more characters to get result.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminAccountsGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminAccountsGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/cache/b2b`
     * Admin API request handler.
     * @summary Admin API handler
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminCacheB2bDelete(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCacheB2bDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/cache/b2b/partners/{partner_id}`
     * Admin API request handler.
     * @summary Deletes partner resources from cache for given identifiers.
     * @param {string} partnerId Partner ID
     * @param {string} [partnerSlug] Partner Slug
     * @param {string} [parentPartnerId] Parent Partner ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminCacheB2bPartnersPartnerIdDelete(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCacheB2bPartnersPartnerIdDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships`
     * Admin API request handler.
     * @summary Admin API handler
     * @param {string} partnerId Partner ID
     * @param {string} [isDependentGroup] Is dependent group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCacheB2bPartnersPartnerIdSponsorshipsDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/cache/b2b/partners/{partner_id}/sponsorships/{sponsorship_id}/referrals`
     * Clears data cached in the referrals key for the specified partner id and sponsorship id. Clears data for all supported languages.
     * @summary Clears cached referral data.
     * @param {string} partnerId Partner ID
     * @param {string} sponsorshipId Sponsorship ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminCacheB2bPartnersPartnerIdSponsorshipsSponsorshipIdReferralsDelete(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/eligibility-partners`
     *
     * @summary Returns partner configs for file-based eligibility partners
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminEligibilityPartnersGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminEligibilityPartnersGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/partners/{partner_id}/eligibility/members/search`
     * Eligibility Search Admin API handler that fuzzy searches members on a partner\'s eligibility list.
     * @summary Eligibility Search Admin API handler
     * @param {string} partnerId The ID of the partner
     * @param {string} [memberId] Id of the member to search
     * @param {string} [email] Email of the member to search
     * @param {string} [firstName] First name of the member to search
     * @param {string} [lastName] Last name of the member to search
     * @param {string} [dob] Date of birth of the member to search.  full-date notation as defined by [RFC 3339, section 5.6](https://datatracker.ietf.org/doc/html/rfc3339#section-5.6), for example, 2017-07-21
     * @param {string} [subscriberId] SubscriberId of the member to search.
     * @param {string} [partnerMemberId] Id of the member in the partner system saved in our DB to search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminPartnersPartnerIdEligibilityMembersSearchGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/recipient/{recipient_id}`
     * Admin API request handler.
     * @summary Admin API handler
     * @param {number} recipientId Recipient ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminRecipientRecipientIdGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminRecipientRecipientIdGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/users/{user_id}`
     *
     * @summary Returns user sponsor, dependents, and parents.
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminUsersUserIdGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminUsersUserIdGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/users/{user_id}/tokens/blocked`
     *
     * @summary Returns timestamp when user active tokens got blocked.
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminUsersUserIdTokensBlockedGet(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminUsersUserIdTokensBlockedGet(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/admin/users/{user_id}/tokens/blocked`
     * Invalidates active access tokens of the user specified by user_id parameter.
     * @summary Blocks user active tokens
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    v1AdminUsersUserIdTokensBlockedPost(params, options) {
        return (0, exports.AdminApiFp)(this.configuration)
            .v1AdminUsersUserIdTokensBlockedPost(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.AdminApi = AdminApi;
//# sourceMappingURL=admin-api.js.map